import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'

export const FormButtons = (props) => {
  const { hideClear, successBlock,submitText } = props
  return (
    <div style={{ display: 'flow-root' }}>
      <br />
      {!hideClear && (
        <ReactBootstrap.Button
          style={{ paddingLeft: '0px' }}
          variant="link"
          className="float-left btn text-dark btn-sm"
          type="button"
          disabled={props.pristine || props.submitting}
          onClick={props.reset}
        >
          Clear
        </ReactBootstrap.Button>
      )}

      {!successBlock ? (
        <ReactBootstrap.Button
          className={'float-end'}
          variant="dark"
          type="submit"
          disabled={props.submitting}
        >
          {props.submitting ? 'Hold' : submitText|| 'Submit'}
        </ReactBootstrap.Button>
      ) : (
        <ReactBootstrap.Button
          block
          className={'float-end'}
          variant="dark"
          type="submit"
          disabled={props.submitting}
        >
          {props.submitting ? 'Hold' : submitText ||'Submit'}
        </ReactBootstrap.Button>
      )}
    </div>
  )
}
